import React from 'react';
import ConnectToAmazonButton from './ConnectButton';
import ConnectAmazonDialog from './ConnectDialog';
import { useDialogsContext } from '../../contexts/Dialog';

export default function ConnectAmazonAccount({
  contained = true,
  primary = true,
  fontSize = 1,
  lines = null,
  disabled = false,
}) {
  const dialogs: any = useDialogsContext();

  return (
    <React.Fragment>
      <ConnectToAmazonButton
        contained={contained}
        primary={primary}
        fontSize={fontSize}
        disabled={disabled}
      />
      <ConnectAmazonDialog
        open={dialogs.connectAmazonSeller}
        handleClose={() => dialogs.close('connectAmazonSeller')}
        lines={lines}
      />
    </React.Fragment>
  );
}
